<template lang="html">
  <div>
    <div class="lately_header_top">
      <van-nav-bar
        title="最近评论"
        left-arrow
        fixed
        @click-left="onClickLeft"/>
    </div>
    <div class="la_content">
      <ul class="la_cont_list">
        <router-link tag="li" v-for="(item, index) in LatelyData" key="index" class="la_cont_item" to="">
          <div class="item_left">
            <h2>{{item.subject}}</h2>
            <span>{{item.author}}</span>
            <em v-html="item.dateline"></em>
          </div>
          <div class="item_right">
            <img :src="`http://ucenter.jmgo.com/avatar.php?uid=${item.authorid}&size=middle`" alt="">
          </div>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import utilAxios from '@/utils/axios'
import { Toast } from 'vant'
import { NavBar } from 'vant'

Vue.use(Toast)
Vue.use(NavBar)
export default {
  data() {
    return {
      LatelyData: []
    }
  },
  created() {
    this.getLatelyData()
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    getLatelyData() {
      utilAxios.get({
        url: '/new_api.php?module=home&mod=space&do=thread&view=me&type=reply&from=space',
        method: 'GET',
        callback: (res) => {
          console.log(res)
          if (res.data.code == 100) {
            this.LatelyData = res.data.threads.list
            console.log(this.LatelyData);
            /*if (res.data.threads.list == 0) {
              Toast('暂无评论')
            }*/
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.la_content {
    margin-top: 0.46rem;
    .la_cont_list {
        padding: 0.1rem;
        background: #fff;
        .la_cont_item {
            display: flex;
            padding: 0.1rem 0;
            border-bottom: 1px solid #eaeaea;
            .item_left {
                flex: 1;
                h2 {
                    font-size: 0.14rem;
                    color: #222;
                    line-height: 0.2rem;
                }
                span {
                    font-size: 0.12rem;
                    color: #666;
                    line-height: 0.3rem;
                    margin-right: 0.1rem;
                }
                em {
                    font-size: 0.12rem;
                    color: #888;
                    line-height: 0.3rem;
                }
            }
            .item_right {
                width: 0.6rem;
                height: 0.6rem;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Lately/Lately.vue